// src/pages/Requests.jsx
import React, { useEffect, useState } from "react";
import api from "../api";
import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import "./Requests.css";

const Requests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchRequests = async () => {
        try {
            const res = await api.get("/books/requests");
            setRequests(res.data.requests || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests();
    }, []);

    const handleAction = async (id, action) => {
        try {
            await api.post(`/books/requests/${id}/${action}`);
            setRequests((prev) => prev.filter((r) => r._id !== id));
        } catch (err) {
            console.error(err);
            alert("Action failed");
        }
    };

    return (
        <div className="requests-page">

            {/* PREMIUM HEADER */}
            <header className="requests-header">
                <i className="bi bi-arrow-left back-btn" onClick={() => navigate(-1)}></i>
                <h1 className="req-title">Requests</h1>
            </header>

            <div className="requests-body">

                {loading ? (
                    <p className="premium-text">Loading...</p>
                ) : requests.length === 0 ? (
                    <p className="premium-text">No pending requests 🎉</p>
                ) : (
                    <div className="req-list">
                        {requests.map((req) => (
                            <div key={req._id} className="req-card fade-in">

                                {/* TEXT INFO */}
                                <div className="req-info">
                                    <h3 className="req-book">{req.bookName}</h3>
                                    <p className="req-user">Invited By: {req.invitedBy}</p>
                                    <p className="req-role">Requested Role: {req.role}</p>
                                </div>

                                {/* BUTTONS */}
                                <div className="req-actions">
                                    <button
                                        className="btn-accept ripple"
                                        onClick={() => handleAction(req._id, "accept")}
                                    >
                                        <i className="bi bi-check-circle-fill me-1"></i> Accept
                                    </button>

                                    <button
                                        className="btn-reject ripple"
                                        onClick={() => handleAction(req._id, "reject")}
                                    >
                                        <i className="bi bi-x-circle-fill me-1"></i> Reject
                                    </button>
                                </div>

                            </div>
                        ))}
                    </div>
                )}

            </div>

            <BottomNav />
        </div>
    );
};

export default Requests;
